import { LocalizedCountry } from "../../../types/country"
import Image from "next/image"

export function CountryImageName({ country }: { country: LocalizedCountry }) {
  return (
    <div className={"countryImageDiv"}>
      {country.image && (
        <Image
          src={country.image.path}
          alt={country.name}
          className={"countryImage"}
          layout={"intrinsic"}
          width={30}
          height={30}
        />
      )}
      {country.name}
    </div>
  )
}
